import React, { memo } from "react";
import { btnType } from "../../constant/dumpStartDraw";

const Welcome = (props) => {
    const { onStartDraw } = props;

    const onSetStartDraw = (result) => {
        onStartDraw && onStartDraw(result)
    }

    return <div className="w-100 h-100 lay1">
        <div className="cus-wel h-100">
            {
                btnType.mt.map((item, i) => {
                    const { result, label } = item;
                    return <button key={i} className="button-start"
                                   onClick={() => onSetStartDraw(result)}>{label}</button>
                })
            }
        </div>
    </div>
}
export default memo(Welcome);
